// Toast — reads toasts from `useUiStore` and renders a stack.

import { useUiStore } from "@/store/ui";

export function useToast() {
  return useUiStore(s => s.toast);
}

export function ToastStack() {
  const toasts = useUiStore(s => s.toasts);
  const dismiss = useUiStore(s => s.dismissToast);
  if (toasts.length === 0) return null;
  return (
    <div className="lex-toast-stack" role="region" aria-label="Notifications" aria-live="polite">
      {toasts.map(t => (
        <div key={t.id} className="lex-toast" data-tone={t.tone} role="status">
          <span style={{ flex: 1 }}>{t.message}</span>
          <button
            type="button"
            className="lex-toast__close"
            aria-label="Dismiss notification"
            onClick={() => dismiss(t.id)}
          >×</button>
        </div>
      ))}
    </div>
  );
}

export const Toast = ToastStack;
export default ToastStack;
